import { Box, Link, Typography } from "@mui/material";
import classes from './ErrorPage.module.scss';
import Notification from "../../views/notification/Notification";
import { NotificationSeverities } from "../../enums/NotificationSeverities";

const ErrorPage = ({ error }: any) => {

  return (
    <Box>
      <Box>
        <Notification
          open={true}
          onClose={() => { }}
          severity={NotificationSeverities.ERROR}
          message={error.message}
          position={{ vertical: 'top', horizontal: 'center' }}
        />
      </Box>
      <Box className={classes['message-box']}>
        <Typography align='center'>{error.message}</Typography>
        <Link className='d-flex justify-content-center' href='/'> Go Home </Link>
      </Box>
    </Box>
  );
};

export default ErrorPage;
